import React, { useCallback } from "react";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";

import { RecordList as GenericRecordList, RecordListProps } from "@app/component/RecordList";
import localSettings from "@app/config/LocalSettings";
import { MAP_RECORDS_PAGE_SIZE } from "@app/scene/map/utils/consts";

import GroupsRoutesPinInfo from "./components/GroupsRoutesPinInfo";

interface Props<T>
  extends Omit<RecordListProps<T>, "alerts" | "overrideFieldVisibility" | "pageSize"> {
  pinGroupsAndRoutesByDefault?: boolean;
}

const RecordList = <T,>({ pinGroupsAndRoutesByDefault, ...props }: Props<T>) => {
  const [groupsAndRoutesVisibility, , hideGroupsAndRoutes] = useBoolean(
    pinGroupsAndRoutesByDefault && !localSettings.shouldPreventPinningGroupsAndRoutesOnMapPage()
  );

  const handleHideGroupsAndRoutesInfo = useCallback(() => {
    hideGroupsAndRoutes();
    localSettings.preventPinningGroupsAndRoutesOnMapPage();
  }, [hideGroupsAndRoutes]);

  const handleCheckFieldVisibility = useCallback(
    (field: IField) =>
      (groupsAndRoutesVisibility &&
        field.hasAnyFeature(FieldFeature.ROUTE_FIELD, FieldFeature.GROUP_FIELD)) ||
      undefined,
    [groupsAndRoutesVisibility]
  );

  return (
    <GenericRecordList
      {...props}
      alerts={<GroupsRoutesPinInfo onUndo={handleHideGroupsAndRoutesInfo} />}
      overrideFieldVisibility={handleCheckFieldVisibility}
      pageSize={MAP_RECORDS_PAGE_SIZE}
    />
  );
};

export default RecordList;
